@if (company$ | async; as company) {
  <div class="column">
    <div class="font-bold ellipsis flex items-center gap-2">
      <ng-container *ngTemplateOutlet="textWithTooltip; context: { text: company.name }"></ng-container>
      @if (company.description) {
        <app-info-icon
          class="relative top-0.5"
          [ngbTooltip]="company.description"
          [keepOnHover]="true"
          [placement]="'top'"
        ></app-info-icon>
      }
    </div>
  </div>

  <div class="column">
    <div
      class="rounded-full text-white font-bold text-sm py-1 px-4 select-none"
      [class.bg-blue-60]="company.is_active"
      [class.bg-pink-90]="!company.is_active"
    >
      {{ buildTranslationKey(company.is_active ? 'active' : 'blocked') | translate }}
    </div>
  </div>

  <div class="column">
    <div class="font-bold">
      {{ userCount }}
    </div>
  </div>

  <div class="column">
    <app-created-source-label [source]="company.created_source"></app-created-source-label>
  </div>

  <div class="column">
    {{ company.created_at | localDate: dateFormat }}
  </div>

  <div class="column">
    <app-company-nda-status [companyId]="company.id"></app-company-nda-status>
  </div>

  <div class="column">
    @if (company.permission_profile_id) {
      <app-profile-dropdown [profileId]="company.permission_profile_id" [readonly]="true"></app-profile-dropdown>
    }
  </div>

  <div class="column">
    <div class="flex items-center justify-content-end w-full mr-6">
      <app-toggle
        class="flex-1"
        [class.hidden]="!company.is_active"
        [ngModel]="autoApprovalEnabled"
        (ngModelChange)="updateAutoApproval($event)"
      ></app-toggle>
      @if (menuActionLoader$ | async) {
        <div class="w-6 h-6">
          <app-circle-loader [appearance]="'dark'"></app-circle-loader>
        </div>
      } @else {
        <app-three-dots-menu [menuActions]="menuActions"></app-three-dots-menu>
      }
    </div>
  </div>
}

<ng-template #textWithTooltip let-text="text">
  <span
    class="whitespace-nowrap truncate min-w-0"
    [ngbTooltip]="text"
    [openTooltipWhenOverflowedAndHovered]="true"
    [openOnWidthOverflow]="true"
    [placement]="'top'"
  >
    {{ text }}
  </span>
</ng-template>
